import { Badge, useTheme } from '@mui/material';
import { ReactComponent as NotificationBellIcon } from 'assett/icons/bell_icon.svg';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from 'store/store';
import { Box, Button, Typography } from 'styles';
import { useTranslation } from 'utils/translations';

export const NotificationsButton = () => {
	const navigate = useNavigate();
	const theme = useTheme();
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: 'clientLabels',
	});
	const { totalClaims } = useSelector((store: RootState) => store.claims);

	return (
		<Box width="fit-content">
			<Button variant="linkDark" onClick={() => navigate('/claims-notifications')}>
				<Badge badgeContent={totalClaims} color="error" overlap="circular">
					<NotificationBellIcon />
				</Badge>
				<Typography
					sx={{ textDecoration: 'underline', textUnderlineOffset: '5px' }}
					variant="button"
					color={theme.palette.error.main}
				>
					{tClientLabels('dashboard.notifications', {
						quantity: totalClaims,
					})}
				</Typography>
			</Button>
		</Box>
	);
};
